import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationLoginService {
  private notificationType: string;

  public setNotificationType(value: string): void {
    this.notificationType = value;
  }

  public getNotificationType(): string {
    return this.notificationType;
  }
}
